"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSegments = exports.formatData = exports.parseMetrics = void 0;
const lodash_1 = __importDefault(require("lodash"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("./constants");
function parseMetrics(rawMetrics, dotOptions) {
  return rawMetrics.map(rm => {
    const opts = lodash_1.default.defaultsDeep({}, rm, dotOptions);
    return {
      ...opts,
      dot1Color: (0, colors_1.parseColor)(opts.dot1Color, constants_1.DEFAULT_DOT1_COLOR),
      dot1StrokeColor: (0, colors_1.parseColor)(opts.dot1StrokeColor, constants_1.DEFAULT_DOT1_STROKE_COLOR),
      dot2Color: (0, colors_1.parseColor)(opts.dot2Color, constants_1.DEFAULT_DOT2_COLOR),
      dot2StrokeColor: (0, colors_1.parseColor)(opts.dot2StrokeColor, constants_1.DEFAULT_DOT2_STROKE_COLOR),
      lineColor: (0, colors_1.parseColor)(opts.lineColor, constants_1.DEFAULT_DOT_LINE_COLOR),
      featured: Boolean(rm.featured),
      selected: Boolean(rm.selected)
    };
  });
}
exports.parseMetrics = parseMetrics;
function formatData(_ref) {
  let {
    data,
    selectedKey1,
    selectedKey2,
    featuredPosition = false,
    sort = false
  } = _ref;
  let dotData = (0, lodash_1.default)(data).map(d => ({
    ...d,
    data1: lodash_1.default.find(d.data, {
      key: selectedKey1
    }),
    data2: lodash_1.default.find(d.data, {
      key: selectedKey2
    })
  }));
  if (sort) {
    dotData = dotData.orderBy([i => lodash_1.default.get(i, 'data2.value', 0)], [sort === 'ascending' ? 'asc' : 'desc']);
  }
  if (featuredPosition) {
    dotData = dotData.orderBy([i => i.metric.featured], [featuredPosition === 'bottom' ? 'asc' : 'desc']);
  }
  return dotData.value();
}
exports.formatData = formatData;
function initSegments(_ref2) {
  let {
    fontSize,
    height,
    data,
    initialY = 0,
    textColor,
    xScale,
    chartWidth
  } = _ref2;
  const segments = [];
  const spacers = [];
  const hasSelected = data.some(i => i.metric.selected);
  data.forEach((_ref3, i, dataArr) => {
    let {
      id,
      name,
      metric,
      metric: {
        featured,
        selected,
        lineColor,
        lineWidth
      }
    } = _ref3;
    let y = i * height + spacers.length * constants_1.DEFAULT_FEATURED_BAR_SPACER_HEIGHT + initialY;
    if (i > 0 && dataArr[i - 1].metric.featured !== featured) {
      spacers.push({
        color: constants_1.DEFAULT_FEATURED_BAR_SPACER_COLOR,
        height: constants_1.DEFAULT_FEATURED_BAR_SPACER_HEIGHT,
        width: chartWidth,
        x: 0,
        y
      });
      y += constants_1.DEFAULT_FEATURED_BAR_SPACER_HEIGHT;
    }
    const dotData = dataArr[i];
    const dots = [];
    [dotData.data1, dotData.data2].forEach((dat, dIndex, dArr) => {
      const dotNum = dIndex + 1;
      const key = `${id}-${dotNum}`;
      let opacity = dotNum === 1 ? constants_1.DEFAULT_DOT_1_OPACITY : constants_1.DEFAULT_DOT_2_OPACITY;
      if (hasSelected && !selected) {
        opacity = constants_1.DEFAULT_UNSELECTED_DOT_OPACITY;
      }
      // Hack to fix react rendering issue when connected dot data
      // didn't exist on previously selected item
      let d;
      if (dat) {
        d = {
          ...dat
        };
      } else if (dIndex === 0 && dArr[1]) {
        d = {
          ...dArr[1]
        };
        opacity = 0;
      } else if (dIndex === 1 && dArr[0]) {
        d = {
          ...dArr[0]
        };
        opacity = 0;
      }
      dots.push({
        data: d,
        dot: {
          key,
          color: metric[`dot${dotNum}Color`],
          opacity,
          radius: metric[`dot${dotNum}Radius`],
          strokeColor: metric[`dot${dotNum}StrokeColor`],
          strokeWidth: metric[`dot${dotNum}StokeWidth`],
          y: y + height / 2
        }
      });
    });
    segments.push({
      label: {
        key: id,
        content: name,
        x: 0,
        y: y + height / 2 + fontSize / 4,
        style: {
          fill: textColor,
          opacity: !hasSelected || selected ? constants_1.DEFAULT_LABEL_OPACITY : constants_1.DEFAULT_UNSELECTED_DOT_OPACITY,
          fontSize,
          fontWeight: constants_1.DEFAULT_LABEL_FONT_WEIGHT
        }
      },
      dots: dots.filter(_ref4 => {
        let {
          data
        } = _ref4;
        return data !== undefined;
      }).map(_ref5 => {
        let {
          data,
          dot
        } = _ref5;
        return {
          data,
          dot: {
            ...dot,
            x: xScale(data.value)
          }
        };
      }),
      line: {
        width: lineWidth,
        color: lineColor
      }
    });
  });
  return {
    segments,
    spacers
  };
}
exports.initSegments = initSegments;